import React, { useEffect } from 'react'
import styled from 'styled-components'
import AppPreview from './AppPreview'

const NewApp = props => {
  const {
    homeStickers,
    newStickers,
    searchStickers,
    topStickers,
    assistants,
    setIsNewBanner,
    page,
    isLoading,
    lang,
    width,
  } = props

  return (
    <div style={{ height: 'calc(100% - 60px)' }}>
      <AppPreview
        homeStickers={homeStickers}
        newStickers={newStickers}
        searchStickers={searchStickers}
        topStickers={topStickers}
        assistants={assistants}
        setIsNewBanner={setIsNewBanner}
        page={page}
        isLoading={isLoading}
        lang={lang}
        width={width}
      />
    </div>
  )
}

export default NewApp
